// This comment tells ESLint that __webpack_public_path__ is a global variable so it doesn't complain about it
/* global __webpack_public_path__ */
import config from "../../config";
import mock from "./mock.json";
import type { ResponseData } from "./types";

class HttpException extends Error {
  code: number | null;
  body: any;
  json: any;

  constructor(message: string, code: number | null = null, body: any = null) {
    super(message);
    this.code = code;
    this.body = body;
    this.json = this.tryParseMessage(message);
  }

  private tryParseMessage(msg: string): object {
    try {
      return JSON.parse(msg);
    } catch (err) {
      console.error(err);
      return {};
    }
  }

  toString(): string {
    return `${this.code}: ${this.message}`;
  }
}

export async function getData(): Promise<ResponseData> {
  const params = new URLSearchParams(window.location.search);
  const useMock = params && params.has("mock") && config.isLocalDev;
  if (useMock) return mock as ResponseData;

  let orgParam = "";
  if (params.get("org")) {
    const qs = new URLSearchParams();
    qs.set("org", params.get("org") || "");
    orgParam = `?${qs}`;
  }
  const resourceUrl = `${__webpack_public_path__}api/data${orgParam}`;
  const reqParams: RequestInit = {
    cache: "no-cache",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  };

  let res: Response;
  try {
    res = await window.fetch(resourceUrl, reqParams);
  } catch (err) {
    console.log(err);
    throw err;
  }

  if (!res.ok) {
    throw new HttpException(await res.text(), res.status);
  }

  return (await res.json()) as ResponseData;
}
